import { ModalHeader } from 'reactstrap'
import React from 'react'
import Resx from '@/components/Resx'

export const BasicHeader = ({ closeDialog, title, localizedTitle, className }) =>
  <ModalHeader className={className} toggle={() => closeDialog()}>
    {localizedTitle !== undefined ? localizedTitle : <Resx name={title} />}
  </ModalHeader>



// WEBPACK FOOTER //
// ./src/dialogs/common/basicHeader.js